import { ObjectWms } from "../../assets/ts/ObjectWms";

let align_center = "text-align:center;";
const trackingTemplate = function (dataItem) {
    const { TrackingNumber, TrackingUrl } = dataItem;
    if (TrackingNumber != null) {
        if (TrackingUrl !== "") {
            return `<a href='${TrackingUrl}' target='_blank' class='tracking-url'>${TrackingNumber}</a>`;
        }
        console.log(TrackingNumber);
        return TrackingNumber;
    }
    return "";
};
const estimatedDeliveryDateTemplate = function (dataItem) {
    if (dataItem.EstimatedDeliveryDate != null) {
        var dateStr = dataItem.EstimatedDeliveryDate;
        // Extract time part based on format (ISO or space-separated)
        var timeStr = dateStr.includes("T") ? dateStr.split("T")[1] : dateStr.split(" ")[1] || "00:00:00";
        if (timeStr.startsWith("00:00:00")) {
            return (window as any).moment(dateStr).format("MMM DD YYYY");
        } else {
            // Convert from PDT to local browser timezone for non-midnight times
            // Parse the date string and treat it as PDT (UTC-7)
            var isoDateStr = dateStr.replace(" ", "T");
            // var pdtMoment = (window as any).moment(isoDateStr).utcOffset(-7, true);
            // return pdtMoment.local().format("MMM DD YYYY hh:mm A");
            return (window as any).moment(isoDateStr).format("MMM DD YYYY hh:mm A");
        }
    }
    return "-";
};

export const getParcelShipmentsColumns = (GridHeaders) => {
    return {
        columns: [
            {
                field: "RowNumber",
                title: "#",
                width: 60,
                wmsid: 1,
                hidden: false,
                locked: true,
                lockable: false,
                resizable: false,
                sortable: false,
                reorderable: false,
                filterable: false,
                attributes: { style: align_center },
                headerAttributes: { style: align_center },
            },
            {
                field: "OrderId",
                title: GridHeaders[14].description,
                width: 120,
                wmsid: 20,
                locked: false,
                lockable: false,
                headerAttributes: {
                    "data-wms-selector": "ParcelShipmentsTransactionId",
                },
            },
            {
                field: "PackageId",
                title: GridHeaders[4].description,
                width: 120,
                wmsid: 3,
                locked: false,
                lockable: false,
                headerAttributes: {
                    "data-wms-selector": "ParcelShipmentsPackageId",
                },
            },
            {
                field: "Carrier",
                title: GridHeaders[1].description,
                width: 120,
                wmsid: 5,
                locked: false,
                lockable: false,
                headerAttributes: {
                    "data-wms-selector": "ParcelShipmentsCarrier",
                },
            },
            {
                field: "TrackingNumber",
                title: GridHeaders[15].description,
                width: 120,
                wmsid: 6,
                locked: false,
                lockable: false,
                headerAttributes: {
                    "data-wms-selector": "ParcelShipmentsTrackingNumber",
                },
                template: trackingTemplate,
            },
            {
                field: "EstimatedDeliveryDate",
                title: GridHeaders[17].description,
                width: 120,
                wmsid: 22,
                locked: false,
                lockable: false,
                headerAttributes: {
                    "data-wms-selector": "ParcelShipmentsEstimatedDelivery",
                },
                template: estimatedDeliveryDateTemplate,
            },
            {
                field: "DeliveryDate",
                title: GridHeaders[0].description,
                width: 120,
                wmsid: 2,
                locked: false,
                lockable: false,
                headerAttributes: {
                    "data-wms-selector": "ParcelShipmentsActualDelivery",
                },
                template:
                    "#= DeliveryDate != null ? kendo.toString(kendo.parseDate(DeliveryDate), 'MMM dd yyyy, hh:mm:ss tt') : '-' #",
            },
            {
                field: "DeliveryStatus",
                title: GridHeaders[3].description,
                width: 120,
                wmsid: 6,
                locked: false,
                lockable: false,
                headerAttributes: {
                    "data-wms-selector": "ParcelShipmentsDeliveryStatus",
                },
                template: function (dataItem) {
                    let color = "rgba(0, 0, 0, 0.08)";
                    let FontColor = "black";
                    let statusName = "Label Created";
                    let width = "104px";
                    if (dataItem.DeliveryStatus === "unknown") {
                        statusName = "Unknown";
                    } else if (dataItem.DeliveryStatus === "accepted") {
                        color = "#03A9F4";
                        FontColor = "white";
                        statusName = "Accepted";
                    } else if (dataItem.DeliveryStatus === "inTransit") {
                        color = "#0288D1";
                        FontColor = "white";
                        statusName = "In Transit";
                    } else if (dataItem.DeliveryStatus === "delivered") {
                        color = "#488C18";
                        FontColor = "white";
                        statusName = "Delivered";
                    } else if (dataItem.DeliveryStatus === "exception") {
                        color = "#D91C03";
                        FontColor = "white";
                        statusName = "Exception";
                    }
                    return `<span class="tag-wrapper" style="background-color:${color};color:${FontColor};height:24px;border-radius:100px;padding: 3px 4px;align-items:center;justify-content:flex-start;justify-content: center;display:flex;white-space:nowrap;margin:2px;margin-right: 10px;width: ${width};">${statusName}</span>`;
                },
            },
            {
                field: "ShipDate",
                title: GridHeaders[18].description,
                width: 120,
                wmsid: 23,
                locked: false,
                lockable: false,
                headerAttributes: {
                    "data-wms-selector": "SmallParcelShipDate",
                },
                template:
                    "#= ShipDate != null ? kendo.toString(kendo.parseDate(ShipDate), 'MMM dd yyyy, hh:mm:ss tt') : '-' #",
            },
        ],
    };
};

export const getParcelShipmentsAllColumnList = (GridHeaders) => {
    return [
        {
            field: "RowNumber",
            title: "RowNumber",
            width: 60,
            wmsid: 1,
            hidden: false,
            locked: true,
            lockable: false,
            resizable: false,
            sortable: false,
            reorderable: false,
            filterable: false,
            attributes: { style: align_center },
            headerAttributes: { style: align_center },
        },
        {
            field: "EstimatedDeliveryDate",
            title: GridHeaders[17].description,
            width: 120,
            wmsid: 22,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsEstimatedDelivery",
            },
            template: estimatedDeliveryDateTemplate,
        },
        {
            field: "DeliveryDate",
            title: GridHeaders[0].description,
            width: 120,
            wmsid: 2,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsActualDelivery",
            },
            template:
                "#= DeliveryDate != null ? kendo.toString(kendo.parseDate(DeliveryDate), 'MMM dd yyyy, hh:mm:ss tt') : '-' #",
        },
        {
            field: "Carrier",
            title: GridHeaders[1].description,
            width: 120,
            wmsid: 3,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsCarrier",
            },
        },
        {
            field: "Customer",
            title: GridHeaders[2].description,
            width: 120,
            wmsid: 5,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsCustomer",
            },
        },
        {
            field: "DeliveryStatus",
            title: GridHeaders[3].description,
            width: 120,
            wmsid: 6,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsDeliveryStatus",
            },
        },
        {
            field: "PackageId",
            title: GridHeaders[4].description,
            width: 120,
            wmsid: 4,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsPackageId",
            },
        },
        {
            field: "PONumber",
            title: GridHeaders[5].description,
            width: 120,
            wmsid: 8,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsPONumber",
            },
        },
        {
            field: "ReferenceNum",
            title: GridHeaders[6].description,
            width: 120,
            wmsid: 10,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsReferenceNum",
            },
        },
        {
            field: "ShipService",
            title: GridHeaders[7].description,
            width: 120,
            wmsid: 11,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsShipService",
            },
        },
        {
            field: "ShipToAddress",
            title: GridHeaders[8].description,
            width: 120,
            wmsid: 12,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsShipToAddress",
            },
        },
        {
            field: "ShipToAddress2",
            title: GridHeaders[9].description,
            width: 120,
            wmsid: 14,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsShipToAddress2",
            },
        },
        {
            field: "ShipToCity",
            title: GridHeaders[10].description,
            width: 120,
            wmsid: 9,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsShipToCity",
            },
        },
        {
            field: "ShipToCountry",
            title: GridHeaders[11].description,
            width: 120,
            wmsid: 15,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsShipToCountry",
            },
        },
        {
            field: "ShipToState",
            title: GridHeaders[12].description,
            width: 120,
            wmsid: 16,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsShipToState",
            },
        },
        {
            field: "ShipToZip",
            title: GridHeaders[13].description,
            width: 120,
            wmsid: 17,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsShipToZip",
            },
        },
        {
            field: "OrderId",
            title: GridHeaders[14].description,
            width: 120,
            wmsid: 19,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsTransactionId",
            },
        },
        {
            field: "TrackingNumber",
            title: GridHeaders[15].description,
            width: 120,
            wmsid: 20,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsTrackingNumber",
            },
            template: trackingTemplate,
        },
        {
            field: "Warehouse",
            title: GridHeaders[16].description,
            width: 120,
            wmsid: 21,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "ParcelShipmentsWarehouse",
            },
        },
        {
            field: "ShipDate",
            title: GridHeaders[18].description,
            width: 120,
            wmsid: 23,
            locked: false,
            lockable: false,
            headerAttributes: {
                "data-wms-selector": "SmallParcelShipDate",
            },
            template:
                "#= ShipDate != null ? kendo.toString(kendo.parseDate(ShipDate), 'MMM dd yyyy, hh:mm:ss tt') : '-' #",
        },
    ];
};

/**
 * Values match API / grid row data; labels match parcel search status multiselect.
 * Used for Kendo column filter dropdown (header filter menu).
 */
export const getParcelShipmentsDeliveryStatusFilterOptions = () => [
    { text: "Label Created", value: "notYetInsystem" },
    { text: "Unknown", value: "unknown" },
    { text: "Accepted", value: "accepted" },
    { text: "In Transit", value: "inTransit" },
    { text: "Delivered", value: "delivered" },
    { text: "Exception", value: "exception" },
];

/**
 * Re-applies non-serializable `filterable.ui` after metadata merge (saved views use `filterable: true` only).
 */
export function applyParcelShipmentsDeliveryStatusFilterUi(columns: any[] | undefined): any[] {
    if (!Array.isArray(columns)) {
        return columns;
    }
    return columns.map((col) => {
        if (col.field !== "DeliveryStatus") {
            return col;
        }
        return {
            ...col,
            filterable: {
                extra: false,
                operators: {
                    string: {
                        eq: "Is equal to",
                        neq: "Is not equal to",
                    },
                },
                ui: function (element: any) {
                    element.removeClass("k-textbox");
                    element.kendoDropDownList({
                        dataSource: getParcelShipmentsDeliveryStatusFilterOptions(),
                        dataTextField: "text",
                        dataValueField: "value",
                        valuePrimitive: true,
                        optionLabel:
                            typeof window !== "undefined" && (window as any).translate
                                ? (window as any).translate("Label_Delivery_Status_Filter_Placeholder")
                                : "Select status…",
                    });
                },
            },
        };
    });
}

/**
 * Parcel tracking only: same column merge as VirtualGridComponent + Delivery Status filter dropdown.
 * Pass result as metaGridConfig so the shared grid stays free of tracking-specific hooks.
 */
export function buildParcelShipmentsMetaGridConfigForVirtualGrid(
    metaGridConfig: string | Record<string, unknown> | undefined | null,
    allColumns: any[],
    defaultColumns: any[]
): string {
    if (metaGridConfig == null || metaGridConfig === "") {
        return "";
    }
    let gridOptions: any;
    try {
        const dateParser =
            typeof window !== "undefined" &&
            (window as any).JSON &&
            typeof (window as any).JSON.dateParser === "function"
                ? (window as any).JSON.dateParser
                : undefined;
        gridOptions =
            typeof metaGridConfig === "string"
                ? JSON.parse(metaGridConfig as string, dateParser)
                : { ...(metaGridConfig as Record<string, unknown>) };
    } catch {
        return typeof metaGridConfig === "string" ? (metaGridConfig as string) : "";
    }

    if (!gridOptions || !gridOptions.columns) {
        return typeof metaGridConfig === "string" ? (metaGridConfig as string) : JSON.stringify(metaGridConfig);
    }

    const fieldArray = gridOptions.columns.map((el: any) => el.field);
    const updateColumn: any[] = [];
    allColumns.forEach((column) => {
        const inSavedLayout = fieldArray.indexOf(column.field) !== -1;
        const lockedExtra = column.locked && !column.isShawRowNumberColumnInList;
        if (inSavedLayout || lockedExtra) {
            updateColumn.push(column);
        }
    });

    let tempObject = ObjectWms.alignIndexesByPropertyVirtual(gridOptions.columns, updateColumn, "field");
    tempObject = applyParcelShipmentsDeliveryStatusFilterUi(tempObject);

    return JSON.stringify({
        ...gridOptions,
        columns: tempObject,
    });
}

export const getParcelShipmentsSchema = () => {
    return {
        model: {
            id: "RowNumber",
            fields: {
                ActualDelivery: { type: "string" },
                Carrier: { type: "string" },
                Customer: { type: "string" },
                DeliveryStatus: { type: "string" },
                PackageId: { type: "number" },
                Reference: { type: "string" },
                PONumber: { type: "string" },
                ShipService: { type: "string" },
                TransactionId: { type: "number" },
                TrackingNumber: { type: "string" },
                Warehouse: { type: "string" },
                RowNumber: { type: "number" },
            },
        },
    };
};
